import { render, staticRenderFns } from "./RealNameApplyJP.vue?vue&type=template&id=773c14c3&scoped=true&"
import script from "./RealNameApplyJP.vue?vue&type=script&lang=js&"
export * from "./RealNameApplyJP.vue?vue&type=script&lang=js&"
import style0 from "./RealNameApplyJP.vue?vue&type=style&index=0&id=773c14c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773c14c3",
  null
  
)

export default component.exports